import { styled, View } from '@red-ui/components/'

export const CarouselTileChipWrapper = styled(View, {
  position: 'absolute',
  zIndex: 2,
  top: '$2',
  left: '$2',
})
